<template>
  <div class="hedge-os">
    <tool-bar pageTitle="hedgeOS"></tool-bar>

    <!-- <nav class="tabs">
      <button v-for="(persona, index) in localizedTabs" :key="persona.id" :class="{ active: hedgeOSStore.activePersona === persona.id }" class="white--text"
        @click="hedgeOSStore.setActivePersona(persona.id)">
        <small>0{{ index + 1 }} / {{ persona.group }}</small>
        <strong>{{ $t('hedgeOS.dashboard.the') }} <em>{{ persona.title }}</em></strong>
        <span>{{ persona.subtitle }}</span>
      </button>
    </nav> -->
    <base-page-layout
      v-if="!handleBlur"
      :visible-operations="localizedOperations"
      :operation-headers="localizedOperationHeaders"
      :active-persona="hedgeOSStore.activePersona"
      :content="localizedTabContent"
      :filters="localizedFilters"
      :ui-content="localizedLayoutContent"
      :active-filter="hedgeOSStore.activeFilter"
      :expanded="hedgeOSStore.expanded"
      :ticket-open="hedgeOSStore.ticketOpen"
      :new-operation-open="hedgeOSStore.newOperationOpen"
      :toast="hedgeOSStore.toast"
      @filter-change="hedgeOSStore.setActiveFilter($event)"
      @toggle-operation="hedgeOSStore.toggleOperation($event)"
      @signal-action="hedgeOSStore.handleSignalAction()"
      @open-new-operation="hedgeOSStore.openNewOperation()"
      @close-drawer="hedgeOSStore.closeDrawer()"
      @complete-action="hedgeOSStore.completeAction($t('hedgeOS.dashboard.notifications.hedge'), $t('hedgeOS.dashboard.notifications.operation'))"
    />
    <div v-else>
      <img src="../assets/blur_imgs/blur1.png" :alt="$t('extras.blurredImageLockedAlt')">
    </div>

  </div>
</template>

<script>
import BasePageLayout from '@/components/HedgeOS/layout/BasePageLayout.vue';
import ToolBar from '@/components/layout/ToolBar.vue';
import { mapStores } from "pinia";
import { useHedgeOSStore } from "@/store/hedgeOSStore";
import { useCoreStore } from "@/store/coreStore";

export default {
  name: "hedgeOS",
  components:{
    ToolBar,
    BasePageLayout
  },
  computed: {
    ...mapStores(useHedgeOSStore),
    ...mapStores(useCoreStore),
    handleBlur() {
      return this.coreStore.evaluateBlur(this.$options.name)
    },
    localizedTabs() {
      return ["cfo", "agri", "desk"].map(id => ({
        id,
        group: this.$t(`hedgeOS.tabs.${id}Group`),
        title: this.$t(`hedgeOS.tabs.${id}Title`),
        subtitle: this.$t(`hedgeOS.tabs.${id}Subtitle`),
      }));
    },
    localizedOperationHeaders() {
      const keyByValue = { operation: "operation", risk: "risk", notional: "notional", mtm: "mtm", coverage: "coverage", settles: "settles", status: "status" };
      return this.hedgeOSStore.operationHeaders.map(header => ({
        ...header,
        text: header.value === "id" ? "ID" : this.$t(`hedgeOS.dashboard.headers.${keyByValue[header.value]}`),
      }));
    },
    localizedFilters() {
      const keys = ["all", "imports", "exports", "fxOnly", "fxCommodity", "unhedged", "under30"];
      return this.hedgeOSStore.operationFilters.map((value, index) => ({
        value,
        label: this.$t(`hedgeOS.dashboard.filters.${keys[index]}`),
      }));
    },
    localizedOperations() {
      return this.hedgeOSStore.visibleOperations.map(item => ({
        ...item,
        directionClass: item.direction.toLowerCase(),
        direction: this.$t(`hedgeOS.dashboard.${item.direction.toLowerCase()}`),
        status: this.$t(`hedgeOS.dashboard.${item.statusClass === "partial" ? "partial" : item.statusClass === "hedged" ? "designated" : "unhedged"}`),
      }));
    },
    localizedLayoutContent() {
      const source = this.hedgeOSStore.layoutContent;
      const t = key => this.$t(`hedgeOS.dashboard.${key}`);
      return {
        ...source,
        filterLabel: t("filter"),
        operationDetails: {
          operation: { title: t("operationDetails"), settlementPrefix: t("settlement") },
          risk: { title: t("riskDecomposition"), description: t("liveCurves") },
          hedges: { title: t("linkedHedges"), description: t("aggregateMtm") },
        },
      };
    },
    localizedTabContent() {
      const source = this.hedgeOSStore.activeTabContent;
      const id = this.hedgeOSStore.activePersona;
      const t = key => this.$t(`hedgeOS.dashboard.${key}`);
      const labels = id === "cfo"
        ? ["liveOperations", "totalNotional", "aggregateHedgeMtm", "netOpenRisk"]
        : id === "agri"
          ? ["physicalInventory", "lockedMargin", "hedgeCoverage", "portBasis"]
          : ["bookNotional", "netDelta", "bookMtm", "marginCalls"];
      const grid = Object.fromEntries(Object.entries(source.grid).map(([key, item], index) => [
        key, { ...item, label: t(labels[index]) },
      ]));
      const labelKeys = { Basis: "basis", Margin: "margin", Premium: "premium", "Credit line": "creditLine", "Next call": "nextCall" };
      const statusKeys = { "ACTION REQUIRED": "actionRequired", HEALTHY: "healthy", WATCH: "watch" };
      const cards = source.section.cards && source.section.cards.map(card => ({
        ...card,
        status: statusKeys[card.status] ? t(statusKeys[card.status]) : card.status.replace("HEDGED", t("hedged")),
        metrics: card.metrics.map(metric => ({ ...metric, label: labelKeys[metric.label] ? t(labelKeys[metric.label]) : metric.label })),
      }));
      const sectionKeys = id === "cfo"
        ? ["operationsLedger", "operationsMeta"]
        : id === "agri"
          ? ["physicalBook", "physicalMeta"]
          : ["corporateCoverage", "corporateMeta"];
      return {
        ...source,
        title: t(`${id}Title`),
        desc: t(`${id}Desc`),
        grid,
        signal: {
          ...source.signal,
          label: `● ${t(id === "desk" ? "alert" : "signal")} · ${source.signal.label.split("·").pop().trim()}`,
          text: t(`${id}Signal`),
          action: t(id === "cfo" ? "buildHedgeAction" : id === "agri" ? "stageOrder" : "openAccounts"),
        },
        section: {
          ...source.section,
          ...(cards ? { cards } : {}),
          title: t(sectionKeys[0]),
          meta: t(sectionKeys[1]),
          action: id === "cfo" ? `+ ${t("newOperation")}` : source.section.action,
        },
      };
    },
  },
};
</script>

<style scoped>
.hedge-os {
    --ink: #0b0d0c;
    --ink2: #131615;
    --ink3: #1c201e;
    --line: #2a2f2c;
    --paper: #f3efe6;
    --dim: #c9c3b3;
    --muted: #8a857a;
    --hot: #ffb000;
    --cool: #7bc4a4;
    --warn: #e8b64a;
    --grid: rgba(243,239,230,.06);
  --surface: #15171c;
  --surface-2: #1b1e24;
    color: var(--paper);
    font-family: "Inter Tight", sans-serif;
    position: relative
}
.tabs {
  margin-top:4.7rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-bottom: 1px solid var(--surface-2);
}

.tabs button {
  border: 0;
  border-right: 2px solid var(--surface-2);
  background: var(--surface);
  padding: 22px 28px;
  text-align: left;
  position: relative
}

.tabs button.active {
  background: var(--surface-2) !important;
}

.tabs button.active:before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 3px;
  background: var(--hot)
}

.tabs small,
.persona-placeholder>small {
  display: block;
  /* font: 10px "JetBrains Mono"; */
  letter-spacing: .18em;
  color: var(--muted)
}

.tabs .active small {
  color: var(--hot)
}

.tabs strong {
  display: block;
  font: 600 21px Fraunces;
  margin: 5px 0
}

.tabs strong em {
  font-weight: 300;
  color: var(--dim)
}

.tabs span {
  font-size: 12px;
  color: var(--muted)
}

</style>
